export default {
  init() {
    // JavaScript to be fired on the home page
    $(window).load(function() {
      $('.flexslider').flexslider({
        controlNav: false,
        animation: 'slide',
      });
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js